/**
 * useCommunityMembersInfinite Hook
 * Fetches community members with infinite scroll using React Query
 */

import { useInfiniteQuery } from "@tanstack/react-query"
import { PAGINATION } from "@/constants/constants"
import { type GetCommunityMembersParams, getCommunityMembers } from "../services/community.service"

interface UseCommunityMembersInfiniteOptions {
  role?: GetCommunityMembersParams["role"]
  searchQuery?: string
}

export function useCommunityMembersInfinite(
  communityId: string,
  options: UseCommunityMembersInfiniteOptions = {},
) {
  const { role, searchQuery } = options

  return useInfiniteQuery({
    queryKey: ["communityMembers", communityId, role, searchQuery],
    queryFn: ({ pageParam = PAGINATION.DEFAULT_PAGE }) =>
      getCommunityMembers(communityId, {
        page: pageParam,
        limit: PAGINATION.MEMBER_LIST_LIMIT,
        role,
        search: searchQuery || undefined,
      }),
    initialPageParam: 1,
    getNextPageParam: lastPage =>
      lastPage.pagination.hasMore ? lastPage.pagination.page + 1 : undefined,
    enabled: !!communityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
